<div class='fade show' style='text-align: center; padding-top: calc(100vh / 2); height: 100vh'>
    <i class='spinner-grow spinner-grow-sm'></i>
    <span class='m-1'>Loading...</span>
</div>
